<template>
  <el-descriptions class="scale-descriptions" :label-style="{color: '#86909c'}" :column="4" direction="vertical">
    <slot slot="title" name="title"></slot>
    <slot slot="extra" name="extra"></slot>
    <el-descriptions-item label="量表编码">{{ scaleInfo.scaleCode }}</el-descriptions-item>
    <el-descriptions-item label="量表名称">{{ scaleInfo.scaleName }}</el-descriptions-item>
    <el-descriptions-item label="量表类型">{{ scaleTypeMap[scaleInfo.scaleType] }}</el-descriptions-item>
    <el-descriptions-item label="总分">{{ scaleInfo.totalScore }}</el-descriptions-item>
    <el-descriptions-item label="维度" :span="wdSpan">{{ getWd(scaleInfo.wdcodes) }}</el-descriptions-item>
    <el-descriptions-item label="排序方式">{{ sortType[scaleInfo.sortType] }}</el-descriptions-item>
    <el-descriptions-item label="题型顺序" :span="subjectTypeSortSpan" v-if="scaleInfo.sortType === 2">
      <el-tag
          class="mr10"
          :key="item"
          v-for="(item, index) in scaleInfo.subjectTypeSort.split(',')"
          size="medium"
          :type="['', 'success', 'info', 'warning', 'danger'][(index + 5) % 5]"
      >{{ subjectTypeMap[item] }}</el-tag>
    </el-descriptions-item>
    <el-descriptions-item label="题目随机" v-if="scaleInfo.sortType === 2">{{ subjectRandom[scaleInfo.subjectRandom] }}</el-descriptions-item>
    <el-descriptions-item label="选项随机">{{ optionRandom[scaleInfo.optionRandom] }}</el-descriptions-item>
    <el-descriptions-item label="出题方式">{{ chosenType[scaleInfo.chosenType] }}</el-descriptions-item>
    <el-descriptions-item label="是否展示分数">{{ enableType[scaleInfo.enableType] }}</el-descriptions-item>
    <el-descriptions-item label="限时">{{ scaleInfo.limitedTime && `${scaleInfo.limitedTime / 1000}秒` }}</el-descriptions-item>
    <el-descriptions-item label="量表答题模板">{{ scaleTemplate[scaleInfo.scaleTemplate] }}</el-descriptions-item>
    <el-descriptions-item v-if="blankSpan" :span="blankSpan"></el-descriptions-item><!-- 占位使用 -->
    <el-descriptions-item label="千人千卷规则" :span="4" v-if="scaleInfo.chosenType === 2">{{ subjectRule }}</el-descriptions-item>
    <el-descriptions-item label="备注" :span="4">{{ scaleInfo.remarks }}</el-descriptions-item>
  </el-descriptions>
</template>

<script>
import ElDescriptions from '@/components/descriptions'
import ElDescriptionsItem from '@/components/descriptions-item'
import {dictionary} from "@/api/openApi";
import {getWdList} from "@/api/subjectInfo";
export default {
  name: "scaleView",
  components: {
    ElDescriptions,
    ElDescriptionsItem,
  },
  props: {
    scaleInfo: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      scaleType: {
        1: '常规量表',
        2: '非常规量表'
      },
      enableType: {
        1: '是',
        2: '否'
      },
      scaleTemplate: {
        1: '列表',
        2: '单题'
      },
      sortType: {
        0: '默认顺序',
        1: '无规则随机',
        2: '自定义题型顺序',
      },
      subjectRandom: {
        0: '否',
        1: '是',
      },
      optionRandom: {
        0: '否',
        1: '是',
      },
      chosenType: {
        1: '固定题目',
        2: '千人千卷',
      },
      wdMap: {},
      subjectTypeMap: {},
      scaleTypeMap: {
        1: '常规量表',
        2: '非常规量表',
      }
    }
  },
  computed: {
    getWd() {
      return (wdcodes) => {
        if (!wdcodes) {
          return ''
        }
        let wdcodeList = wdcodes.split(',')
        return wdcodeList.map(item => {
          return this.wdMap[item] || item
        }).join('，')
      }
    },
    wdSpan() {
      let wd = this.getWd(this.scaleInfo.wdcodes)
      if (wd.length <= 44) {
        return 1
      } else if (wd.length <= 88) {
        return 2
      } else if (wd.length <= 132) {
        return 3
      } else {
        return 4
      }
    },
    subjectTypeSortSpan() {
      let subjectTypeSort = this.scaleInfo.subjectTypeSort.split(',')
      if (subjectTypeSort.length <= 3) {
        return 1
      } else if (subjectTypeSort.length <= 7) {
        return 2
      } else {
        return 3
      }
    },
    subjectRule() {
      if (!this.scaleInfo.subjectRule) {
        return ''
      }
      return this.scaleInfo.subjectRule.map(v => {
        return `【${this.subjectTypeMap[v.subjectType]}】抽取  ${v.count}  道`
      }).join('，')
    },
    blankSpan() {
      let count = 1 + 1 + 1 + 1 + this.wdSpan + 1 + (this.scaleInfo.sortType === 2 ? this.subjectTypeSortSpan : 0) + 1 + 1 + 1 + 1 + 1
      if (count % 4 !== 0) {
        return 4 - count % 4
      } else {
        return 0
      }
    }
  },
  mounted() {
    this.initDictionary()
  },
  methods: {
    async initDictionary() {
      let { code, data } = await dictionary('SUBJECT_TYPE')
      if (code === 200) {
        for (let i = 0; i < data.length; i++) {
          this.$set(this.subjectTypeMap, data[i].metaCode, data[i].metaName)
        }
      }
      getWdList().then(res => {
        if (res.code === 200) {
          res.data.forEach(item => {
            this.$set(this.wdMap, item.wdcode, item.wdname)
          })
        }
      })
    },
  }
};
</script>
<style lang="scss" scoped>
  .scale-descriptions {
  }
</style>
